document.addEventListener("DOMContentLoaded", function () {
  if (window.location.pathname === "/") {
    var quickBuyButtons = document.querySelectorAll(".js-quickbuy-button");

    quickBuyButtons.forEach(function (button) {
      button.textContent = "Quick View";
    });
  }

  if (
    window.location.href.includes("/products/") ||
    window.matchMedia("(max-width: 767px)").matches
  ) {
    var style = document.createElement("style");

    style.innerHTML = ".kl-teaser-XARmHS { display: none !important; }";

    document.head.appendChild(style);
  }

  if (window.location.href.includes("/products/")) {
    const targetNode = document.querySelector(
      '[id*="shopify-block-qikify_upsell_gift_bogo_offer"].shopify-block.shopify-app-block'
    );

    if (targetNode) {
      const config = { childList: true, subtree: true };

      const callback = function (mutationsList, observer) {
        for (let mutation of mutationsList) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                const offer1 = node.querySelector(
                  'a.qbk-offer__title[href="/products/4-x-screen-protector-for-iphone"]'
                );

                const offer2 = node.querySelector(
                  'a.qbk-offer__title[href="/products/full-cover-anti-spy-screen-protector-for-iphone"]'
                );

                const offer3 = node.querySelector(
                  'a.qbk-offer__title[href="/products/fluorescent-glow-in-the-dark-tempered-glass-screen-protector-for-iphone"]'
                );

                const offer4 = node.querySelector(
                  'a.qbk-offer__title[href="/products/3-x-hydrogel-film-screen-protector-for-samsung"]'
                );

                const offer5 = node.querySelector(
                  'a.qbk-offer__title[href="/products/privacy-screen-protector-for-samsung-s-series"]'
                );

                const offer6 = node.querySelector(
                  'a.qbk-offer__title[href="/products/full-cover-anti-spy-tempered-glass-for-samsung-a-series"]'
                );

                if (offer1) {
                  offer1.querySelector("span").textContent =
                    "9H Tempered Glass (Pack of 2)";
                }

                if (offer2) {
                  offer2.querySelector("span").textContent =
                    "Full Cover Anti-Spy (Pack of 2)";
                }

                if (offer3) {
                  offer3.querySelector("span").textContent =
                    "Fluorescent Glow Tempered Glass";
                }

                if (offer4) {
                  offer4.querySelector("span").textContent =
                    "Hydrogel Screen Protector (Pack of 3)";
                }

                if (offer5) {
                  offer5.querySelector("span").textContent =
                    "Full Cover Anti-Spy (S Series)";
                }

                if (offer6) {
                  offer6.querySelector("span").textContent =
                    "Full Cover Anti-Spy (A Series)";
                }
              }
            });
          }
        }
      };

      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
    }
  }

  const observer = new MutationObserver(function (mutationsList) {
    for (let mutation of mutationsList) {
      if (mutation.type === "childList") {
        const newElement = document.querySelector("#glFilter-search-popup");
        //   const miniCart = document.querySelector("#qikify-stickycart-v2-app");

        if (newElement) {
          if (window.innerWidth >= 1000) {
            const searchInput = document.querySelector(
              ".gl-d-searchbox .gl-d-searchbox-input"
            );

            if (searchInput) {
              searchInput.setAttribute(
                "placeholder",
                "Search for products, categories, or brands..."
              );
            }
          }

          const closeBtn = document.querySelector(
            "#glFilter-search-popup .gl-d-close-btn"
          );
          const searchFormCloseBtn = document.querySelector(
            ".utils__item.search-bar .js-search-form-close"
          );

          if (closeBtn && searchFormCloseBtn) {
            closeBtn.addEventListener("click", function () {
              searchFormCloseBtn.click();
            });
          }
        }

        //   if (miniCart) {
        //     // const freeShippingThreshold = 35;

        //     // function updateShippingGoal() {
        //     //   const subtotalElement = document.querySelector(
        //     //     ".qsc2-mini-cart .qsc2-drawer .qsc2-drawer-footer .qsc2-drawer-footer__summary-subtotal-price > div"
        //     //   );
        //     //   const shippingGoalMsgElement = document.querySelector(
        //     //     ".qsc2-mini-cart .qsc2-drawer .qsc2-drawer-header__shipping-goal .qsc2-drawer-header__shipping-goal-msg"
        //     //   );

        //     //   if (subtotalElement && shippingGoalMsgElement) {
        //     //     let subtotalText = subtotalElement.textContent.trim();
        //     //     let currencySymbol = subtotalText[0];
        //     //     let subtotal = parseFloat(subtotalText.replace(/[^0-9.-]+/g, ""));

        //     //     let amountLeft = freeShippingThreshold - subtotal;

        //     //     if (currencySymbol === "£") {
        //     //       if (amountLeft > 0) {
        //     //         shippingGoalMsgElement.innerHTML = `Spend <strong>£${amountLeft.toFixed(
        //     //           2
        //     //         )}</strong> more to get FREE delivery!`;
        //     //       } else {
        //     //         shippingGoalMsgElement.innerHTML = `Congratulations! You qualify for FREE delivery!`;
        //     //       }
        //     //     }
        //     //   }
        //     // }

        //     // updateShippingGoal();

        //     let subtotalElement = document.querySelector(
        //       ".qsc2-mini-cart .qsc2-drawer .qsc2-drawer-footer .qsc2-drawer-footer__summary-subtotal-price > div"
        //     );

        //     const miniCartElement = document.querySelector(".qsc2-mini-cart");

        //     if (miniCartElement || subtotalElement) {
        //       const observer = new MutationObserver(function (mutationsList) {
        //         mutationsList.forEach(function (mutation) {
        //           if (
        //             miniCartElement &&
        //             mutation.type === "attributes" &&
        //             mutation.attributeName === "class"
        //           ) {
        //             if (
        //               !miniCartElement.classList.contains("qsc2-mini-cart--empty")
        //             ) {
        //               updateShippingGoal();

        //               subtotalElement = document.querySelector(
        //                 ".qsc2-mini-cart .qsc2-drawer .qsc2-drawer-footer .qsc2-drawer-footer__summary-subtotal-price > div"
        //               );

        //               if (subtotalElement) {
        //                 observer.observe(subtotalElement, {
        //                   childList: true,
        //                   subtree: true,
        //                   characterData: true,
        //                 });
        //               }
        //             }
        //           }

        //           if (
        //             subtotalElement &&
        //             (mutation.type === "childList" ||
        //               mutation.type === "characterData")
        //           ) {
        //             updateShippingGoal();
        //           }
        //         });
        //       });

        //       if (miniCartElement) {
        //         observer.observe(miniCartElement, { attributes: true });
        //       }

        //       if (subtotalElement) {
        //         observer.observe(subtotalElement, {
        //           childList: true,
        //           subtree: true,
        //           characterData: true,
        //         });
        //       }
        //     }
        //   }
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: false });

  // Collection description Read more / Read less toggle
  var descToggle = document.querySelector('[data-collection-desc-toggle]');
  var descWrapper = document.querySelector('[data-collection-desc]');
  if (descToggle && descWrapper) {
    function toggleDescription() {
      var expanded = descWrapper.classList.toggle('is-expanded');
      descToggle.textContent = expanded ? 'Read less' : 'Read more';
    }

    descToggle.addEventListener('click', toggleDescription);

    descToggle.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        toggleDescription();
      }
    });
  }

  // Phone Model bottom sheet picker
  var pickerTrigger = document.querySelector('[data-phone-picker-trigger]');
  var pickerBackdrop = document.querySelector('[data-phone-picker-backdrop]');
  var pickerClose = document.querySelector('[data-phone-picker-close]');

  if (pickerTrigger) {
    function openPicker() {
      document.body.setAttribute('data-phone-picker-open', '');
      pickerTrigger.setAttribute('aria-expanded', 'true');
    }
    function closePicker() {
      document.body.removeAttribute('data-phone-picker-open');
      pickerTrigger.setAttribute('aria-expanded', 'false');
    }

    pickerTrigger.addEventListener('click', openPicker);

    if (pickerBackdrop) {
      pickerBackdrop.addEventListener('click', closePicker);
    }
    if (pickerClose) {
      pickerClose.addEventListener('click', closePicker);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && document.body.hasAttribute('data-phone-picker-open')) {
        closePicker();
      }
    });
  }
});
